import { render, staticRenderFns } from "./Consorcios.vue?vue&type=template&id=892532fc&"
import script from "./Consorcios.vue?vue&type=script&lang=js&"
export * from "./Consorcios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports